import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

type ComponentProps = Record<string, unknown>;

const LazyPromotionalCampaignsListRoute = lazy(() =>
  retry(() => import('app/pages/admin/PromotionalCampaigns/List')));
const LazyPromotionalCampaignsShowRoute = lazy(() =>
  retry(() => import('app/pages/admin/PromotionalCampaigns/Show')));

export const PromotionalCampaignsList = (props: ComponentProps) =>
  <LazyPromotionalCampaignsListRoute {...props} />;
export const PromotionalCampaignsShow = (props: ComponentProps) =>
  <LazyPromotionalCampaignsShowRoute {...props} />;
